import { TableColumns } from "components/ui/Table";

export const BrandColumns: TableColumns[] = [
  { Header: "Brand Name", accessor: "name" },
];
